
import Vue from 'vue'
import createServiceCategory from '@/connectors/services/create-service-category'
import deleteServiceCategory from '@/connectors/services/delete-service-category'
import {
  updateServiceCategory,
  createService,
  deleteService,
  getServiceCategories,
  updateService
} from '@/connectors/services'
import Loader from '@/components/Loader.vue'
import ServiceCategoryPopup from '@/components/popup/ServiceCategoryPopup.vue'
import ServicePopup from '@/components/popup/ServicePopup.vue'
import ServicesComponent from '@/components/ServicesComponent.vue'
import { ICreateService, IServiceCategory } from '@/types/services'
import { ModalIds } from '@/components/popup/modal-ids'

export default Vue.extend({
  name: 'Services',
  components: { ServicesComponent, ServicePopup, ServiceCategoryPopup, Loader },
  data () {
    return {
      ModalIds,
      loader: false,
      editing: false,
      tree: [] as IServiceCategory[],
      oneCategory: {} as IServiceCategory,
      oneService: {} as Partial<ICreateService>
    }
  },
  computed: {
    idSelectedOrganization (): number {
      if (this.$store.state.profile.select_organization) {
        return this.$store.state.profile.select_organization?.id
      }
      return 0
    }
  },
  mounted () {
    this.pullTree()
  },
  methods: {
    // Открываем модалку для новой категории
    prepareCreateCategory (item) {
      this.editing = false
      this.oneCategory = { ...item }
      this.oneCategory.name = ''
    },
    // Открываем модалку для редактирования категории
    prepareUpdateCategory (category) {
      this.editing = true
      this.oneCategory = { ...category }
    },
    // Открываем модалку для новой услуги
    prepareCreateService (category) {
      this.editing = false
      this.oneCategory = { ...category }
      this.oneService = {}
    },
    // Открываем модалку для редактирования услуги
    prepareUpdateService (service) {
      this.editing = true
      this.oneService = { ...service }
    },
    createDirectory (category) {
      const formData = {
        moid: Number(localStorage.getItem('moid')),
        name: category.name,
        parent_id: category.id
      }
      createServiceCategory(formData)
        .then(() => {
          this.pullTree()
        }).catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    createService (service) {
      service.moid = Number(localStorage.getItem('moid'))
      service.parentId = this.oneCategory.id
      createService(service)
        .then(() => {
          this.pullTree()
        }).catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    updateService (service) {
      service.moid = Number(localStorage.getItem('moid'))
      updateService(service.id, service)
        .then(() => {
          this.pullTree()
        }).catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    updateNameDirectory (category) {
      category.moid = Number(localStorage.getItem('moid'))
      const formData = {
        moid: Number(localStorage.getItem('moid')),
        name: category.name
      }
      updateServiceCategory(category.id, formData)
        .then(() => {
          this.pullTree()
        }).catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    deleteDirectory (id) {
      deleteServiceCategory(id, Number(localStorage.getItem('moid')))
        .then(() => {
          this.pullTree()
        }).catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    deleteService (service) {
      deleteService(service.id, Number(localStorage.getItem('moid')))
        .then(() => {
          this.pullTree()
        }).catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    pullTree () {
      this.loader = true
      if (!Number(localStorage.getItem('moid'))) {
        return
      }
      this.loader = true
      getServiceCategories(Number(localStorage.getItem('moid')))
        .then((res: any) => {
          this.tree = res
          this.loader = false
        }).catch(e => {
          this.loader = false
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    }
  }
})
